// extracted by mini-css-extract-plugin
export default {"clickable":"cwL6XW"};